import { createTranslator } from '@antoja/shared';
import messages from './es-CO.json';

export type MessageKey = keyof typeof messages;

export const t = createTranslator(messages);
